import styled from 'styled-components';
import { zIndex } from 'tokens';

export const Overlay = styled.div`
	position: fixed;
	inset: 0;
	background: rgba(0, 0, 0, 0.85);
	backdrop-filter: blur(8px);
	z-index: ${zIndex.blockingModal};
	display: flex;
	align-items: center;
	justify-content: center;
	animation: overlayShow 150ms cubic-bezier(0.16, 1, 0.3, 1);

	@keyframes overlayShow {
		from {
			opacity: 0;
		}
		to {
			opacity: 1;
		}
	}
`;

export const ModalContainer = styled.div`
	max-width: 1080px;
	width: 100%;
	height: 700px;
	max-height: calc(100vh - 40px);
	background: ${(p) => p.theme.gray[100]};
	border: 1px solid ${(p) => p.theme.gray[200]};
	border-radius: 12px;
	box-shadow: 0 16px 48px rgba(0, 0, 0, 0.6);
	position: relative;
	display: flex;
	flex-direction: column;
	animation: contentShow 150ms cubic-bezier(0.16, 1, 0.3, 1);

	@keyframes contentShow {
		from {
			opacity: 0;
			transform: scale(0.96);
		}
		to {
			opacity: 1;
			transform: scale(1);
		}
	}

	@media (max-width: 768px) {
		max-width: calc(100vw - 32px);
		height: calc(100vh - 32px);
	}
`;

export const Header = styled.div`
	padding: 28px 28px 20px;
	border-bottom: 1px solid ${(p) => p.theme.gray[200]};
	flex-shrink: 0;
`;

export const HeaderTop = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 16px;
`;

export const Title = styled.h2`
	font-size: 18px;
	font-weight: 700;
	color: ${(p) => p.theme.gray[1000]};
	margin: 0;
`;

export const CloseButton = styled.button`
	width: 32px;
	height: 32px;
	background: transparent;
	border: none;
	border-radius: 6px;
	color: ${(p) => p.theme.gray[600]};
	display: flex;
	align-items: center;
	justify-content: center;
	transition: all 0.2s ease;

	&:hover {
		background: ${(p) => p.theme.gray[200]};
		color: ${(p) => p.theme.gray[1000]};
	}
`;

export const SearchContainer = styled.div`
	position: relative;
	margin-bottom: 16px;
`;

export const SearchIcon = styled.div`
	position: absolute;
	left: 12px;
	top: 50%;
	transform: translateY(-50%);
	color: ${(p) => p.theme.gray[400]};
	pointer-events: none;
	display: flex;
	align-items: center;
`;

export const SearchInput = styled.input`
	width: 100%;
	box-sizing: border-box;
	height: 36px;
	background: ${(p) => p.theme.gray[200]};
	border: 1px solid ${(p) => p.theme.gray[200]};
	border-radius: 6px;
	padding: 0 12px 0 36px;
	color: ${(p) => p.theme.gray[1000]};
	font-size: 13px;
	font-family: inherit;
	transition: border-color 0.2s ease;

	&:focus {
		outline: none;
		border-color: ${(p) => p.theme.blue[500]};
	}

	&::placeholder {
		color: ${(p) => p.theme.gray[400]};
	}
`;

export const CategoryPills = styled.div`
	display: flex;
	gap: 8px;
	overflow-x: auto;
	scrollbar-width: none;

	&::-webkit-scrollbar {
		display: none;
	}
`;

export const CategoryPill = styled.button<{ $active?: boolean }>`
	height: 24px;
	padding: 0 12px;
	background: ${(p) => (p.$active ? p.theme.blue[500] : 'transparent')};
	border: 1px solid ${(p) => (p.$active ? p.theme.blue[500] : p.theme.gray[200])};
	border-radius: 12px;
	color: ${(p) => (p.$active ? p.theme.white : p.theme.gray[1000])};
	font-size: 11px;
	font-weight: 500;
	white-space: nowrap;
	flex-shrink: 0;
	transition: all 0.2s ease;
	font-family: inherit;

	&:hover {
		background: ${(p) => (p.$active ? p.theme.blue[500] : p.theme.gray[200])};
	}
`;

export const Content = styled.div`
	flex: 1;
	overflow-y: auto;
	padding: 28px;

	scrollbar-width: thin;
	scrollbar-color: transparent transparent;

	&::-webkit-scrollbar {
		width: 6px;
	}
	&::-webkit-scrollbar-track {
		background: transparent;
	}
	&::-webkit-scrollbar-thumb {
		background-color: transparent;
		border-radius: 3px;
	}

	&:hover {
		scrollbar-color: ${(p) => p.theme.gray[200]} transparent;

		&::-webkit-scrollbar-thumb {
			background-color: ${(p) => p.theme.gray[200]};
		}
	}
`;

export const Grid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(270px, 1fr));
	gap: 20px;
`;

export const EmptyState = styled.div`
	text-align: center;
	padding: 48px 24px;
	color: ${(p) => p.theme.gray[600]};
	font-size: 14px;
	grid-column: 1 / -1;
`;

export const Footer = styled.div`
	padding: 18px 28px;
	background: ${(p) => p.theme.gray[200]};
	border-top: 1px solid ${(p) => p.theme.gray[200]};
	text-align: center;
	flex-shrink: 0;
	border-radius: 0 0 12px 12px;
`;

export const FooterText = styled.p`
	font-size: 14px;
	color: ${(p) => p.theme.gray[700]};
	margin: 0;
`;

export const FooterLink = styled.span`
	color: ${(p) => p.theme.gray[700]};
	font-weight: 600;
	text-decoration: none;
	transition: color 0.2s ease;

	&:hover {
		color: ${(p) => p.theme.gray[1000]};
	}
`;
